import { Checkbox, Text, VStack } from '@genial/components';
import React from 'react';

interface StepTwoSendingChannelProps {
  selectedChannels: string[];
  onSelectionChange: (channels: string[]) => void;
}

const sendingChannelsOptions = [
  { label: 'Push', value: 'push', disabled: true },
  { label: 'Whatsapp', value: 'whatsapp' },
];

export const StepTwoSendingChannel: React.FC<StepTwoSendingChannelProps> = ({
  selectedChannels,
  onSelectionChange,
}) => {
  const handleChannelSelectChange = React.useCallback(
    (value: string, selected: boolean) => {
      if (value !== 'whatsapp') {
        return;
      }

      if (selected) {
        onSelectionChange(['whatsapp']);
        return;
      }

      onSelectionChange([]);
    },
    [onSelectionChange]
  );

  const normalizedSelectedChannels = selectedChannels.includes('whatsapp') ? ['whatsapp'] : [];

  return (
    <VStack space="stack.nano">
      <Text variant="semibold">Canal de envio</Text>
      <Checkbox
        hasError={!normalizedSelectedChannels.length}
        testId="fixed-fee-channel-checkbox"
        options={sendingChannelsOptions}
        onChange={handleChannelSelectChange}
        selectedValues={normalizedSelectedChannels}
        optionPadding={{ bottom: 0, right: 'inline.xxxs' }}
      />
    </VStack>
  );
};
